var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckDroplet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 96C60.7 96 32 124.7 32 160L32 448C32 483.3 60.7 512 96 512L99.3 512C109.7 548.9 143.7 576 184 576C224.3 576 258.2 548.9 268.7 512L371.3 512C381.7 548.9 415.7 576 456 576C496.3 576 530.2 548.9 540.7 512L544 512C579.3 512 608 483.3 608 448L608 301.3C608 284.3 601.3 268 589.3 256L544 210.7C532 198.7 515.7 192 498.7 192L448 192L448 160C448 124.7 419.3 96 384 96L96 96zM544 301.3L544 352L448 352L448 256L498.7 256L544 301.3zM184 448C206.1 448 224 465.9 224 488C224 510.1 206.1 528 184 528C161.9 528 144 510.1 144 488C144 465.9 161.9 448 184 448zM416 488C416 465.9 433.9 448 456 448C478.1 448 496 465.9 496 488C496 510.1 478.1 528 456 528C433.9 528 416 510.1 416 488zM240 368C200.2 368 168 335.8 168 296C168 262.8 202.5 218 223.8 193.6C232.5 183.6 247.6 183.6 256.3 193.6C277.5 218 312.1 262.7 312.1 296C312.1 344 279.9 368 240.1 368z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckDroplet);
export default __webpack_public_path__ + "static/media/truck-droplet.2d6fb9ba40947504160bcb36310f6f65.svg";
export { ForwardRef as ReactComponent };